/**
 * Espone SanitarioAuth come OssAuthContext così si riusano
 * OssFascicoli, OssFascicoloDettaglio, Oss118Dialog senza duplicarli.
 */
import { OssAuthContext } from "../context/OssAuthContext";
import { useSanitarioAuth } from "../context/SanitarioAuthContext";

export default function SanitarioOssBridge({ children }) {
  const { token, activeOperatore, loading, logoutActive } = useSanitarioAuth();

  const value = {
    sessions: activeOperatore ? [activeOperatore] : [],
    activeOss: activeOperatore,
    token,
    loading,
    loginWithPassword: async () => {
      throw new Error("Usare il login del Modulo Sanitario Rapido");
    },
    switchTo: async () => {},
    logoutActive,
    addAnotherUser: () => {},
  };

  return <OssAuthContext.Provider value={value}>{children}</OssAuthContext.Provider>;
}
